import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import {
	UntypedFormBuilder,
	UntypedFormGroup,
	Validators,
} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Subscription } from 'rxjs';

import moment from 'moment';

import { WalletsService } from '../../../../../modules/wallets/wallets.service';
import { SnackBarService } from '../../../../../shared/components/snack-bar/snack-bar.service';

@Component({
	selector: 'app-manage-benefit-date-modal',
	styleUrls: ['./manage-benefit-date-modal.component.scss'],
	templateUrl: './manage-benefit-date-modal.component.html',
})
export class ManageBenefitDateModalComponent implements OnInit, OnDestroy {
	form: UntypedFormGroup;
	isHealth: boolean = false;
	isLoading: boolean = false;

	private onSubmitSubscription$: Subscription = new Subscription();

	constructor(
		public dialogRef: MatDialogRef<ManageBenefitDateModalComponent>,
		private readonly formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA)
		public data: {
			benefitName: string;
			isHealth: boolean;
			walletId: string;
		},
		private readonly snackbarService: SnackBarService,
		private readonly walletsService: WalletsService,
	) {
		this.isHealth = this.data.isHealth;

		this.form = this.formBuilder.group({
			date: [null, [Validators.required]],
			name: [null],
		});
	}

	closeModal() {
		this.dialogRef.close();
	}

	ngOnDestroy(): void {
		this.onSubmitSubscription$.unsubscribe();
	}

	ngOnInit(): void {
		const name = this.form.get('name');
		name?.setValue(this.data.benefitName);
		name?.disable();
	}

	onContinue(): void {
		const date = moment(this.form.get('date')?.value).format(
			'YYYY-MM-DD hh:mm:ssZZ',
		);

		this.isLoading = true;

		this.onSubmitSubscription$ = this.walletsService
			.deleteOneWallet({
				dto: {
					deletedInInsuranceAt: date,
					walletId: this.data.walletId,
				},
			})
			.subscribe(
				async () => {
					this.dialogRef.close('success');
					this.isLoading = false;
				},
				(error) => {
					this.snackbarService.showSnack(error.error?.message, 'error');
					this.isLoading = false;
				},
			);
	}
}
